@if (icon) {
    @if (directCamera) {
        <button (click)="chooseSource()" [hidden]="hide" mat-icon-button type="button">
            <mat-icon class="{{ icon }}"></mat-icon>
        </button>
        <input #uploadInput (change)="uploadFile($event)" [multiple]="multiple" hidden type="file" />
    } @else {
        <div class="d-flex">
            <button class="curpoint" mat-icon-button>
                <div (click)="uploadInput.click()" class="me-1 mt-1">
                    <mat-icon class="{{ icon }}"></mat-icon>
                    <input #uploadInput (change)="uploadFile($event)" [multiple]="multiple" hidden type="file" />
                </div>
            </button>
            @if (remove) {
                <button (click)="callback.emit(null)" mat-icon-button type="button">
                    <mat-icon class="fas fa-trash"></mat-icon>
                </button>
            }
        </div>
    }
} @else {
    <button class="curpoint" mat-raised-button>
        <label style="margin: 0; padding: 0">
            <ng-container>{{ multiple ? 'Bestanden selecteren' : 'Bestand selecteren' }}</ng-container>
            <input #uploadInput (change)="uploadFile($event)" [multiple]="multiple" hidden type="file" />
        </label>
    </button>

    @if (directCamera && !isIos) {
        <button (click)="openModal(null, true)" class="ms-2" mat-raised-button type="button">Camera</button>
    }
}
